<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Customers</div>
	</div>
	<p-divider></p-divider>
	<app-customer-summary></app-customer-summary>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="customerList"
		[loading]="!customerList"
		[globalFilterFields]="app.keys(customerList)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="lastName">
					<div class="d-flex w-100">
						Name
						<p-sortIcon field="lastName"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="lastName" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="lastVisitDate">
					<div class="d-flex w-100">
						Last Visited
						<p-sortIcon field="lastVisitDate"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="date" field="lastVisitDate" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="totalRevenue">
					<div class="d-flex w-100">
						Total Spend
						<p-sortIcon field="totalRevenue"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="number" field="totalRevenue" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="visitCount">
					<div class="d-flex w-100">
						Total Visits
						<p-sortIcon field="visitCount"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="number" field="visitCount" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="averageVisit">
					<div class="d-flex w-100">
						Average Spend
						<p-sortIcon field="averageVisit"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="number" field="averageVisit" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="loyaltyAccount">
					<div class="d-flex w-100">
						Loyalty Member
						<p-sortIcon field="loyaltyAccount"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="boolean" field="loyaltyAccount" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr (click)="routeToCustomer(rec.key)">
				<td>
					<span class="p-column-title">Name</span>
					<fa-icon [icon]="['far', 'head-side-brain']" *ngIf="userService.user.role >= 5" (click)="viewProfile(rec.key)"></fa-icon>
					<div *ngIf="!rec.lastName && !rec.firstName">
						<p-skeleton></p-skeleton>
					</div>
					<div *ngIf="rec.lastName || rec.firstName">
						{{ app.references.toTitleCase(rec.lastName) }}, {{ app.references.toTitleCase(rec.firstName) }}
					</div>
				</td>
				<td>
					<span class="p-column-title">Last Visit</span>
					{{ moment(rec.lastVisitDate).format("l LT") }}
				</td>
				<td>
					<span class="p-column-title">Revenue</span>
					{{ rec.totalRevenue | currency }}
				</td>
				<td>
					<span class="p-column-title">Visits</span>
					{{ rec.visitCount }}
				</td>
				<td>
					<span class="p-column-title">Avg Spend</span>
					{{ rec.totalRevenue / rec.visitCount | currency }}
				</td>
				<td>
					<p-chip *ngIf="rec.loyaltyId" styleClass="p-me-2 custom-chip">Loyalty Member</p-chip>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<app-customer-detail *ngIf="customerSelected" [customer]="customerSelected" (closeEmitter)="customerSelected = undefined"></app-customer-detail>
